var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 *
 * @author: Matthew Rawson @ 15/08/2017 16:38
 * @description: Component to wrap react-slick component
 * @notes:
 *
 * # This component wraps: https://github.com/akiran/react-slick
 * For a full list of settings available.
 *
 *
 *
 * # Small workaround
 * A small work around was put in to get the custom SliderNav components to work properly.
 * For some reason the slidesToShow property isn't auto passed in by the SlickSlider component,
 * so we are manually passing them in as props. This is required to hide / show each SliderNav if on
 * the first or last scrolled page.
 *
 *
 * # Custom CSS to effect the slick slider and its slider track:
 * Pass this into the Slider component as the property 'className' this gets applied to the child SlickSlider.
 *
 * .slick-slider.{custom class name} {}
 * .slick-slider.{custom class name} .slick-track {}
 *
 *
 * # Example responsive settings:
 * import {DESKTOP, TABLET} from "../global/media"; // media query breakpoints
 * {
 * responsive: [
 *   {breakpoint: TABLET, settings: {slidesToShow: 1, slidesToScroll: 1}},
 *   {breakpoint: DESKTOP, settings: {slidesToShow: 2, slidesToScroll: 2}}
 * ]
 * }
 *
 * The responsive guidelines work mobile first, the breakpoint being the max-width those responsive settings
 * apply to. Outside of the responsive breakpoints the slider reverts back to previously defined settings.
 *
 */
import React, { Component } from "react";
import SlickSlider from "react-slick";
import { extend } from "lodash";
import id from "@irati/utils/id";
import SliderNav from "./SliderNav";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./styles/slider.css";
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider(props) {
        var _this = _super.call(this, props) || this;
        _this.defaultSettings = {};
        _this.getSlidesToShow = function (_a) {
            var responsive = _a.responsive, slidesToShow = _a.slidesToShow;
            if (!responsive) {
                return slidesToShow;
            }
            return responsive.reduce(function (currentSlidesToShow, responsiveSetting) {
                if (currentSlidesToShow === slidesToShow && responsiveSetting.breakpoint > window.innerWidth) {
                    return responsiveSetting.settings.slidesToShow;
                }
                return currentSlidesToShow;
            }, slidesToShow);
        };
        _this.slickSlider = React.createRef();
        /** Default settings can be overridden by props.settings object */
        _this.defaultSettings = {
            dots: false,
            infinite: false,
            centerMode: false,
            speed: 500,
            draggable: false,
            showButtons: true,
            slidesToShow: props.slidesToShow,
            slidesToScroll: props.slidesToShow,
            className: props.className || ""
        };
        return _this;
    }
    Slider.prototype.render = function () {
        var idNamespace = id("slider", this.props);
        /** Merge settings from props and defaults */
        var settings = extend(this.defaultSettings, this.props.settings);
        var alwaysShow = settings.centerMode && settings.infinite;
        var mandatorySettings = {
            prevArrow: alwaysShow ? null : (React.createElement(SliderNav, { id: id("nav-left", idNamespace), slidesToShow: this.getSlidesToShow(settings), alwaysShow: alwaysShow, show: settings.showButtons, previousNav: true })),
            nextArrow: alwaysShow ? null : (React.createElement(SliderNav, { id: id("nav-right", idNamespace), slidesToShow: this.getSlidesToShow(settings), alwaysShow: alwaysShow, show: settings.showButtons }))
        };
        /** final settings */
        settings = extend(settings, mandatorySettings);
        return (React.createElement(SlickSlider, __assign({ id: idNamespace }, settings, { ref: this.slickSlider }), this.props.children || React.createElement("div", null)));
    };
    Slider.defaultProps = {
        slidesToShow: 3,
        showButtons: true
    };
    return Slider;
}(Component));
export default Slider;
